/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuRadioSelectSearch_viewer$ref = any;
export type SbSharedRefineMenuFilterLocation_viewer$ref = any;
export type SbSharedRefineMenuFilterLocation_viewer = {
    readonly locations: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly count: number | null;
                readonly displayName: string | null;
                readonly urlLabel: string | null;
                readonly linkReference: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": SbSharedRefineMenuRadioSelectSearch_viewer$ref;
    readonly " $refType": SbSharedRefineMenuFilterLocation_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterLocation_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "locations",
      "name": "itemFacetSearch",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "facetName",
          "value": "location"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "getExactMatches",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        },
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "userZipCode"
        }
      ],
      "concreteType": "ItemFacetsQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemFacetsQueryEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "FilterValueType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "count",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "urlLabel",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "linkReference",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectSearch_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '8b14c1d8e59929c534e629575b69acc5';
export default node;
